import { useHistory } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Chip, IconButton, ListItem, Stack, Typography } from "@mui/material";

import { getDatetimeAndDiffFromTimestamp } from "../../../../utils/time";
import { levelChipColor, levelText } from "../../../AnomalyDetection/utils";
import { AmountInCustomerCurrency } from "../AmountInCustomerCurrency";
import { type AnomalyWithCostAndRef } from "../types";

export const AnomalyRow = ({ anomaly, hideDivider }: { anomaly: AnomalyWithCostAndRef; hideDivider: boolean }) => {
  const history = useHistory();
  const severity = anomaly.metadata.severity ?? 0;

  return (
    <ListItem
      divider
      sx={{ py: 1, borderBottom: hideDivider ? "none" : "1px solid", borderColor: "divider", cursor: "pointer" }}
      onClick={() => {
        history.push(`./monitor/cost-anomalies/${anomaly.ref.path.split("/")[1]}/${anomaly.metadata.alert_id}`);
      }}
    >
      <Stack direction="row" alignItems="center" width="100%" spacing={2}>
        <Box sx={{ minWidth: 0, width: "55%" }}>
          <Typography variant="body2" noWrap sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "block" }}>
            {anomaly.metadata.sku_name ?? anomaly.metadata.service_name}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ textOverflow: "ellipsis", overflow: "hidden", display: "block" }}
          >
            Detected {getDatetimeAndDiffFromTimestamp(anomaly.metadata.timestamp).timeAgo}
            {" | "}
            {anomaly.customerFeedback ? "Acknowledged" : "Not acknowledged"}
          </Typography>
        </Box>
        <Box sx={{ width: "15%" }}>
          <Stack direction="row" alignItems="center" justifySelf="flex-end">
            {anomaly.status === "ACTIVE" ? (
              <Chip variant="status" label="Active" color="success" size="small" />
            ) : (
              <Chip variant="status" label="Inactive" color="default" size="small" />
            )}
          </Stack>
        </Box>
        <Box sx={{ width: "20%" }}>
          <Typography variant="subtitle2" color="text.primary" sx={{ textAlign: "right" }}>
            <AmountInCustomerCurrency amount={anomaly.cost} />
          </Typography>
        </Box>
        <Box sx={{ width: "15%" }}>
          <Stack direction="row" alignItems="center" justifySelf="flex-end">
            <Chip
              variant="status"
              label={severity === 1 ? "Info" : levelText[severity]}
              color={levelChipColor[severity]}
            />
          </Stack>
        </Box>
        <Stack direction="row" alignItems="center" width="1.5rem">
          <IconButton size="small">
            <ChevronRightIcon fontSize="inherit" />
          </IconButton>
        </Stack>
      </Stack>
    </ListItem>
  );
};
